<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.49238 19.7895C9.38279 20.8836 11.6066 21.2529 13.7491 20.8284C15.8917 20.404 17.8068 19.2148 19.1374 17.4826C20.4679 15.7504 21.1232 13.5934 20.9809 11.4137C20.8386 9.23409 19.9085 7.18057 18.3641 5.63605C16.8196 4.09152 14.7662 3.16141 12.5866 3.01913C10.4071 2.87684 8.25016 3.5321 6.51803 4.86272C4.78589 6.19335 3.59676 8.10852 3.17235 10.2512C2.74793 12.3938 3.11719 14.6177 4.21128 16.5082L3.03852 20.0098C2.99445 20.1419 2.98806 20.2837 3.02005 20.4193C3.05204 20.5549 3.12116 20.6789 3.21966 20.7774C3.31816 20.8759 3.44214 20.945 3.57771 20.977C3.71328 21.009 3.85509 21.0026 3.98723 20.9585L7.49238 19.7895Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
